// Common search query: /seo-pricing → /pricing (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/seo-pricing")({
  beforeLoad: () => {
    throw redirect({ to: "/pricing", statusCode: 301 });
  },
});
